import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import logger from "../../../utils/logger";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {

    logger.debug('scroll to top in : ', pathname)

    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

